// The caller's standing in one week's Pick Three, from pick_three_standing
// (migration 083): counts only, withheld by the server until the week has
// locked and ten players have picked. Cached briefly, since it moves only as
// games finish and every viewer of a result would otherwise ask again.
import { useEffect, useState } from "react";
import { supabase } from "../supabase/supabase";
import { useAuth } from "../context/AuthContext";
import { getCached, setCached, IDLE_TTL_MS } from "../utils/queryCache";

/**
 * `enabled` is false until the player has an entry and the week is locked, so
 * the function is not called for a result that cannot exist. Returns the raw
 * standing (`standingBand` in games/pickThree.js reads it), or null.
 */
export function usePickThreeStanding(week, enabled) {
  const { currentUser } = useAuth();
  const userId = currentUser?.id;
  const [standing, setStanding] = useState(null);

  useEffect(() => {
    if (!enabled || week === null || !userId) { setStanding(null); return undefined; }
    const key = `pick3:standing:${week}:${userId}`;
    const cached = getCached(key);
    if (cached !== undefined && cached !== null) { setStanding(cached.value); return undefined; }

    let cancelled = false;
    supabase.rpc("pick_three_standing", { p_week: week }).then(({ data, error }) => {
      if (cancelled || error) return;
      setCached(key, { value: data }, IDLE_TTL_MS);
      setStanding(data);
    });
    return () => { cancelled = true; };
  }, [week, enabled, userId]);

  return standing;
}
